<template>
    <div class="fadein">
        <Goback></Goback>
        <div class="h30"></div>
        <div class="center1200 bg-white padding20 shadow">
            <div class="h20"></div>
            <div class="center-title" style="color:#303133"><img src="/static/img/title-left.png" alt="" class="title-pic"> 关于我们 <img src="/static/img/title-right.png" alt="" class="title-pic"></div>
            <div class="h20"></div>
            <div style="width:1100px;margin:0 auto;line-height: 50px;font-size:18px;">
            <div  style="text-indent:2em;">
                尊敬的用户您好，欢迎访问本网站ヾ(=^▽^=)ノ ~
            </div>
            <!-- <div style="text-indent:2em;">本项目主要包括3个方面——Web网站、微信公众号、微信小程序。</div> -->
            <div style="text-indent:2em;">
                Web网站：作为主要展现形式，为热爱电影的人群而设计。在该网站，您可以浏览到当下热门电影、最新电影，我们可以为您推送电影，您还可以根据分类来筛选您感兴趣的电影。我们的网站是思想的沟通，我们会定期在主页提出有趣的话题，您可以参与投票来表明自己的立场。您还可以关注和支持与您志同道合的论友，参与论坛，发表自己的感慨。我们的网站主张“彼此尊重，求同存异”，对于不法言论，我们零容忍，您可以通过举报来维护这片净土。对于网站不满意的情况，欢迎您随时反馈，我们虚心整改。
            </div>
            <!-- <div style="text-indent:2em;">
                微信公众号：您可以通过关注我们的微信公众号来及时了解本站的信息，也可以实时地与我们互动。
            </div>
            <div style="text-align: center;">
                <img src="/static/img/wechat_gzh.png" alt="">
                <p style="font-size:16px;color:#999;margin-top:-30px;">这个是我们的公众号哟~ヾ(o◕∀◕)ﾉ</p>
            </div>
            <div style="text-indent:2em;">
                微信小程序：我们提供了一个陌生人交友的小程序，您只需点击按钮，即可为您匹配志同道合的论友。
            </div> -->
            </div>
            <div class="h30"></div>
            
        </div>
        <div class="h30"></div>
    </div>
</template>
<script>
    import Goback from '@/components/components/goback';
    export default{
        components:{
            Goback,

        },
    }
</script>
<style scoped>
    
</style>


// WEBPACK FOOTER //
// src/components/index/aboutus.vue